import Vue from "vue";
// import MetaInfo from 'vue-meta-info'
import App from "./App.vue";
import router from "./router";
import iView from "view-design";
import VueI18n from "vue-i18n";
import store from "./store";
import messages from "./lang";
import "view-design/dist/styles/iview.css";
import "./styles/index.less";
import api from "./api";
Vue.prototype.$api = api;
Vue.use(VueI18n);
Vue.use(iView);
// Vue.use(MetaInfo)
Vue.locale = () => {};

const mobileLang = window.localStorage.getItem("mobileLang");
const i18n = new VueI18n({
  locale: mobileLang ? mobileLang : "en", // set locale
  messages, // set locale messages
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
